export const LOGO_MODE_ROUND = 'Round'
export const LOGO_MODE_SQUARE = 'Square'
export const LOGO_MODE_RECTANGLE = 'Rectangle'
export const LOGO_MODE_ONLYTITLE= 'OnlyTitle'
